<script>
import { mapGetters } from 'vuex';
import { getAmericanFundsBaseUrl } from '../../shared/utils/utils';

export default {
	name: 'UnderlyingFundsDataMixin',
	data() {
		return {
			fundAbbreviations: []
		};
	},
	computed: {
		...mapGetters([
			'isAFISTargetDate',
			'strategies',
			'underlyingFunds'
		]),
		widgetData() {
			const dataSet = this.underlyingFunds || {};
			dataSet.isAFISTargetDate = this.isAFISTargetDate;
			dataSet.Application = 'AFIS';

			if (dataSet.Data && dataSet.Data.length) {
				dataSet.Data.forEach(item => {
					// for target date funds link to American Funds detail page using the UnderlyingAFISRetailQuotronSymbol
					if (
						this.isAFISTargetDate &&
						item.UnderlyingAFISRetailQuotronSymbol
					) {
						const baseUrl = getAmericanFundsBaseUrl(this.$store.state.stagingFlag);
						item.url = `${baseUrl}/${this.getAudience}/investments/fund/${item.UnderlyingAFISRetailQuotronSymbol}`;
					// otherwise link to AFIS fund detail page
					} else if (item.UnderlyingFundNumber) {
						// match the underlying fund number with the fund class number from the universe call to find the data for the fund name to be used in the URL when integrated with CG or in PROD
						const fundData =
							this.strategies.find(strategy => {
								return strategy.FundClassNumber.toString() === item.UnderlyingFundNumber.toString();
							}) || {};
						const fundName =
							(fundData.URLName &&
								fundData.ShareClass &&
								`${fundData.URLName}-${fundData.ShareClass}`) ||
							null;
						const fundAbbreviation =
							(item.UnderlyingFundQuotronSymbol &&
								fundData.ShareClass &&
								`${item.UnderlyingFundQuotronSymbol}-${fundData.ShareClass}`) ||
							null;
						//if integrated/Prod use the fund name version, if local/dev/acc(non-integrated) use the accronym
						const fund = this.isMarkitEnvironment ? fundAbbreviation : fundName;
						item.url = (fund && this.dynamicDetailPageLink(fund)) || '';
					}
				});
			}
			this.$EventBus.$emit('ExcelData', 'UnderlyingFundsModule', dataSet);
			return {
				dataSet
			};
		},
		underlyingFundsDataFormatted() {
			try {
				const array =
					(this.widgetData &&
						this.widgetData.dataSet &&
						this.widgetData.dataSet.Data) ||
					[];
				const objectiveList = [
					...new Set(array.map(item => item.UnderlyingFundObjectiveWeb))
				];
				const finalObject = [];
				objectiveList.forEach(objectiveNameWeb => {
					const category = {};
					category[objectiveNameWeb] = array.filter(obj => {
						return obj.UnderlyingFundObjectiveWeb === objectiveNameWeb;
					});
					finalObject.push(category);
				});
				return finalObject;
			} catch (err) {
				console.error('error formatting underlying funds data: ', err); // eslint-disable-line no-console
				return err;
			}
		}
	}
};
</script>
